import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Panel, Overline, Metric, ProgressBar, Icon, PageLoader, SectionTitle } from "../../components/ui-kit";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function ProgressPage() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/student/progress-report").then(({ data }) => setD(data)); }, []);
  if (!d) return <PageLoader />;

  return (
    <div className="max-w-5xl mx-auto p-4 sm:p-6 space-y-6">
      <div className="relative rounded-[28px] p-6 sm:p-7 text-white overflow-hidden" style={{ background: "linear-gradient(135deg,#1d3155,#14213D)" }}>
        <div className="absolute inset-0 dotgrid opacity-50" />
        <div className="relative flex items-center justify-between flex-wrap gap-4">
          <div><Overline className="text-white/70">Your Report</Overline><h1 className="text-3xl sm:text-4xl font-bold mt-1 tracking-tight">Progress & Mastery</h1></div>
          <div className="flex gap-3">
            <div className="glass rounded-2xl px-5 py-3 text-center"><div className="text-2xl font-bold">{d.overall_mastery}%</div><div className="text-[10px] uppercase tracking-wide text-white/70">Mastery</div></div>
            <div className="glass rounded-2xl px-5 py-3 text-center"><div className="text-2xl font-bold">{d.streak}</div><div className="text-[10px] uppercase tracking-wide text-white/70">Day Streak</div></div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Metric icon="Award" label="Mastery" value={`${d.overall_mastery}%`} tone="blue" />
        <Metric icon="BookCheck" label="Completed" value={`${d.completed_topics}/${d.total_topics}`} tone="green" />
        <Metric icon="Target" label="Quiz Average" value={`${d.quiz_average}%`} tone="purple" />
        <Metric icon="Zap" label="XP Earned" value={d.xp} tone="yellow" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Panel>
          <SectionTitle title="Quiz Accuracy Trend" icon="TrendingUp" />
          {d.trend.length ? (
            <ResponsiveContainer width="100%" height={220}>
              <AreaChart data={d.trend}>
                <defs><linearGradient id="pg" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#2477E8" stopOpacity={0.3} /><stop offset="100%" stopColor="#2477E8" stopOpacity={0} /></linearGradient></defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8EEF6" />
                <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#71809B" }} tickFormatter={(v) => v.slice(5)} />
                <YAxis domain={[0, 100]} tick={{ fontSize: 11, fill: "#71809B" }} />
                <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #DCE5F0" }} />
                <Area type="monotone" dataKey="accuracy" stroke="#2477E8" strokeWidth={3} fill="url(#pg)" dot={{ r: 3, fill: "#2477E8" }} />
              </AreaChart>
            </ResponsiveContainer>
          ) : <p className="text-sm text-mim-muted">Take a few quizzes to see your trend.</p>}
        </Panel>
        <Panel>
          <SectionTitle title="Subject Mastery" icon="Layers" />
          <div className="space-y-4">
            {d.subjects.map((s) => (
              <div key={s.id}>
                <div className="flex items-center justify-between mb-1.5 text-sm"><span className="font-semibold text-mim-navy">{s.name}</span><span className="text-mim-muted">{s.completed}/{s.total} · <span className="font-semibold text-mim-navy">{s.mastery}%</span></span></div>
                <ProgressBar value={s.mastery} color={s.color} />
              </div>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
}
